import { Component, OnInit, ViewChild } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import de from '@angular/common/locales/de';

import { ChartComponent } from './chart.component';
import { TableCreditsComponent } from '@usimweb/ui/shared';

import { Projects, Credits } from '@usimweb/core/models';

import { Store } from '@ngrx/store';
import { Observable, skip, zip } from 'rxjs';
import * as fromStore from '@usimweb/state/store';

@Component({
    selector: 'app-credits',
    templateUrl: './credits.component.html',
    styleUrls: ['./credits.component.scss'],
    standalone: false
})
export class CreditsComponent implements OnInit {
  @ViewChild(ChartComponent) private chartComponent!: ChartComponent;
  @ViewChild(TableCreditsComponent) private tableComponent!: TableCreditsComponent;

  public progress$!: Observable<boolean>;
  public data$!: Observable<[Credits, Projects[]]>;

  constructor(private store: Store<fromStore.DashboardState>) {}

  ngOnInit(): void {
    registerLocaleData(de);
    this.getData();
  }

  private getData() {
    this.progress$ = this.store.select<boolean>(fromStore.getProjectsLoading);
    const credits$ = this.store.select(fromStore.getCredits);
    const projects$ = this.store.select(fromStore.getAllProjects);
    this.data$ = zip(credits$, projects$).pipe(skip(1));
  }
  public changeChart(event: any) {
    const showVersion = event.showVersion as boolean;
    const uuid = event.uuid as string;
    showVersion === true ? this.chartComponent.setVersionPieChart(uuid) : this.chartComponent.setProjectPieChart();
  }

  public collapse() {
    this.tableComponent.collapse();
  }
}
